import { render, staticRenderFns } from "./workorderDisplay.vue?vue&type=template&id=08cdc6cd"
import script from "./workorderDisplay.vue?vue&type=script&lang=js"
export * from "./workorderDisplay.vue?vue&type=script&lang=js"
import style0 from "./workorderDisplay.vue?vue&type=style&index=0&id=08cdc6cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports